import {
	CounterPanel,
	CounterText,
	Room,
	RoomHeading,
	ChildPanel,
	RemoveRoom,
	RemoveRoomText
} from './room.styles';

import CounterComponent from '../counter/counter.component';

import { ActionType, Composition } from '../../types/rooms';

import ChildAgeComponent from './child-age.component';
import {
	BadgeComponent,
	BadgeSize,
	BadgeStatus
} from '@vaa-component-lib/component.atom.badge';
import {
	IconActionMinusComponent,
	IconsSize
} from '@vaa-component-lib/component.atom.icons';
import {
	TypographyComponent,
	TypographyVariant,
	TypographySize,
	TypographyWeight
} from '@vaa-component-lib/component.atom.typography';

interface RoomComponentProps {
	id: string;
	roomIdx: number;
	composition: Composition;
	dispatch: React.Dispatch<ActionType>;
	roomsDisabled?: boolean;
}

const RoomComponent = ({
	id,
	roomIdx,
	composition,
	dispatch,
	roomsDisabled = false
}: RoomComponentProps) => {
	const adultLowerLimit = 1;
	const adultUpperLimit = 9;
	const childLowerLimit = 0;
	const childUpperLimit = 8;

	return (
		<Room data-cy="room-component" id={id} idx={roomIdx}>
			{!roomsDisabled && (
				<RoomHeading>
					<BadgeComponent
						status={BadgeStatus.Neutral}
						size={BadgeSize.Small}
						label={`Room ${roomIdx + 1}`}
					/>
					{roomIdx > 0 && (
						<RemoveRoom
							onClick={(): void =>
								dispatch({ type: 'REMOVE_ROOM_BY_INDEX', roomIndex: roomIdx })
							}
							type="button"
							data-testid="remove-room-btn">
							<IconActionMinusComponent size={IconsSize.Xsm} />
							<RemoveRoomText>Remove room</RemoveRoomText>
						</RemoveRoom>
					)}
				</RoomHeading>
			)}
			<CounterPanel noMargin={roomsDisabled}>
				<CounterText data-testid="adult-label">
					<TypographyComponent
						element="p"
						variant={TypographyVariant.Body}
						size={TypographySize.Mdm}
						weight={TypographyWeight.Medium}>
						Adults
					</TypographyComponent>
					<TypographyComponent
						element="span"
						variant={TypographyVariant.Body}
						size={TypographySize.Xsm}
						weight={TypographyWeight.Regular}>
						Age 18 and over
					</TypographyComponent>
				</CounterText>
				<CounterComponent
					id="adult"
					minusDisabled={composition.adults === adultLowerLimit}
					plusDisabled={composition.adults === adultUpperLimit}
					minusOnChange={(): void =>
						dispatch({ type: 'REMOVE_ADULT', roomIndex: roomIdx })
					}
					plusOnChange={(): void =>
						dispatch({ type: 'ADD_ADULT', roomIndex: roomIdx })
					}
					minusLabel="Remove adult"
					plusLabel="Add adult"
					value={composition.adults}
				/>
			</CounterPanel>
			<CounterPanel>
				<CounterText data-testid="child-label">
					<TypographyComponent
						element="p"
						variant={TypographyVariant.Body}
						size={TypographySize.Mdm}
						weight={TypographyWeight.Medium}>
						Children
					</TypographyComponent>
					<TypographyComponent
						element="span"
						variant={TypographyVariant.Body}
						size={TypographySize.Xsm}
						weight={TypographyWeight.Regular}>
						0-17 years old on date of return
					</TypographyComponent>
				</CounterText>
				<CounterComponent
					id="child"
					minusDisabled={composition.childAges.length === childLowerLimit}
					plusDisabled={composition.childAges.length === childUpperLimit}
					minusOnChange={(): void =>
						dispatch({ type: 'REMOVE_CHILD', roomIndex: roomIdx })
					}
					plusOnChange={(): void =>
						dispatch({ type: 'ADD_CHILD', roomIndex: roomIdx })
					}
					minusLabel="Remove child"
					plusLabel="Add child"
					value={composition.childAges.length}
				/>
			</CounterPanel>
			{composition.childAges.length > 0 && (
				<ChildPanel>
					{composition.childAges.map((age, idx) => {
						return (
							<ChildAgeComponent
								age={age}
								key={idx}
								childIdx={idx}
								roomIdx={roomIdx}
								dispatch={dispatch}
							/>
						);
					})}
				</ChildPanel>
			)}
		</Room>
	);
};

export default RoomComponent;
